import { startRegistration, startAuthentication } from '@simplewebauthn/browser';
import type {
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
  RegistrationResponseJSON,
  AuthenticationResponseJSON,
} from '@simplewebauthn/browser';
import { apiGet, apiPost } from './api';

export async function loginWithPasskey(): Promise<void> {
  const { challengeId, options } = await apiPost<{
    challengeId: string;
    options: PublicKeyCredentialRequestOptionsJSON;
  }>('/api/auth/challenge', { mode: 'login' });
  const credential: AuthenticationResponseJSON = await startAuthentication({ optionsJSON: options });
  await apiPost('/api/auth/verify', { challengeId, credential });
}

export async function registerPasskey(bootstrapToken?: string): Promise<{ deviceName: string }> {
  const { challengeId, options } = await apiPost<{
    challengeId: string;
    options: PublicKeyCredentialCreationOptionsJSON;
  }>('/api/auth/challenge', { mode: 'register' });
  const credential: RegistrationResponseJSON = await startRegistration({ optionsJSON: options });
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (bootstrapToken) headers['x-bootstrap-token'] = bootstrapToken;
  const r = await fetch('/api/auth/register', {
    method: 'POST',
    credentials: 'same-origin',
    headers,
    body: JSON.stringify({ challengeId, credential }),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json() as Promise<{ deviceName: string }>;
}

export type AuthStatus = { hasDevices: boolean; devBypass: boolean };

export async function getAuthStatus(): Promise<AuthStatus> {
  return apiGet<AuthStatus>('/api/auth/register-status');
}
